const STORAGE_KEY = 'layout-mode';

/**
 * On first call, checks for `?layout=solidsun-iframe` in the URL
 * and persists the flag to sessionStorage so it survives in-app navigation.
 */
const init = () => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('layout') === 'solidsun-iframe') {
    sessionStorage.setItem(STORAGE_KEY, 'solidsun-iframe');
  }
};

init();

export const isSolidsunIframe = () =>
  sessionStorage.getItem(STORAGE_KEY) === 'solidsun-iframe';
